export default {
  name: "CoutryFilterItem",
  props: {
    item: {
      type: Object,
      required: true
    }
  }
};